import { VisaMetadata } from './getVisaMetadata';

const ALLOWED_VISA_TYPE = 'Student visa (Tier 4 General/Student Route)';
const ALLOWED_VISA_LEVEL = 'Bachelor (UG)';

export const isStudentVisaCalculationAllowed = (metadata: VisaMetadata): boolean => {
  return metadata.visaType === ALLOWED_VISA_TYPE && metadata.level === ALLOWED_VISA_LEVEL;
};
